// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"ea05ca06","202":"6b567fe6","366":"ced3d58a","519":"ced3d58a","525":"8211641e","827":"d1ea5b0a","971":"995f0988"}[chunkId] + ".chunk.css";
};